<div class="branding-container">
  <h3>Branding</h3>
  <p>Configuración de marca, logo, colores y apariencia del local.</p>
  <p>Location ID: {{ locationId }}</p>
</div>
